import { render, staticRenderFns } from "./starBadge.vue?vue&type=template&id=7da0d178&"
import script from "./starBadge.vue?vue&type=script&lang=js&"
export * from "./starBadge.vue?vue&type=script&lang=js&"
import style0 from "./starBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports